import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBrain,
  faChartLine,
  faHeartbeat,
  faUserFriends,
  faChartBar,
  faRobot,
} from "@fortawesome/free-solid-svg-icons";

const solutions = [
  {
    icon: faBrain,
    title: "Content AI",
    description: "AI-powered content creation and lesson planning",
    bgColor: "bg-[#3B5AFF]",
    shadow: "shadow-[0_4px_12px_rgba(59,90,255,0.25)]",
  },
  {
    icon: faChartLine,
    title: "Progression AI",
    description: "Track and optimize student learning progress",
    bgColor: "bg-[#239B3B]",
    shadow: "shadow-[0_10px_15px_rgba(56,181,73,0.3)]",
  },
  {
    icon: faHeartbeat,
    title: "Performance AI",
    description: "Monitor and analyze student performance",
    bgColor: "bg-[#8B3BFF]",
    shadow: "shadow-[0_10px_15px_rgba(139,59,255,0.3)]",
  },
  {
    icon: faUserFriends,
    title: "Personalize AI",
    description: "Customize learning for each student",
    bgColor: "bg-[#FF3B77]",
    shadow: "shadow-[0_4px_12px_rgba(255,59,119,0.25)]",
  },
  {
    icon: faChartBar,
    title: "Analytics AI",
    description: "Data-driven insights for better decisions",
    bgColor: "bg-[#3B5AFF]",
    shadow: "shadow-[0_4px_12px_rgba(59,90,255,0.25)]",
  },
  {
    icon: faRobot,
    title: "Emotional AI",
    description: "Your well-being AI",
    bgColor: "bg-[#8B3BFF]",
    shadow: "shadow-[0_4px_12px_rgba(139,59,255,0.25)]",
  },
    {
    icon: faChartBar,
    title: "Behavioral AI",
    description: "Focus on Human Behavior",
    bgColor: "bg-[#3B5AFF]",
    shadow: "shadow-[0_4px_12px_rgba(59,90,255,0.25)]",
  },
  {
    icon: faRobot,
    title: "Intelligent AI",
    description: "Your Intelligent buddy to answer your quires",
    bgColor: "bg-[#8B3BFF]",
    shadow: "shadow-[0_4px_12px_rgba(139,59,255,0.25)]",
  },
];

const Solutions = () => {
  return (
    <section className="bg-gradient-to-r from-[#e9efff] via-[#f7f5f7] to-[#f7f5f7] min-h-screen">
      <main className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-16">
        <header className="text-center mb-14">
          <h1 className="font-extrabold text-4xl leading-tight">
            Our AI-Powered Solutions
          </h1>
          <p className="mt-3 text-[#3B4A60] text-base font-normal max-w-md mx-auto">
            Comprehensive tools to transform education
          </p>
        </header>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {solutions.map((solution) => (
            <article
              key={solution.title}
              className={`bg-white rounded-xl p-6 ${solution.shadow}`}
            >
              <div
                className={`w-12 h-12 rounded-lg ${solution.bgColor} flex items-center justify-center mb-4`}
              >
                <FontAwesomeIcon icon={solution.icon} className="text-white text-lg" />
              </div>
              <h2 className="font-bold text-lg leading-5 mb-2">
                {solution.title}
              </h2>
              <p className="text-[#3B4A60] text-md font-normal leading-5">
                {solution.description}
              </p>
            </article>
          ))}
        </div>
      </main>
    </section>
  );
};

export default Solutions;